import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SliderGallery } from './sliderGallery'
import { ComponentWillMountSymbol } from 'feature-components'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(SliderGallery)
}

export const editorPage: ContainerModuleLoader = page

export * from './configs'
